// @ts-strict-ignore
import { Component, Input, EventEmitter, Output } from '@angular/core';
import { desc } from '../helpers/desc';
import { environment } from '@env/environment';

@Component({
    // tslint:disable-next-line: component-selector
    selector: '[tmnz-row-child]',
    templateUrl: './row-child.component.html',
    styleUrls: ['./row-child.component.scss'],
    standalone: false
})
export class RowChildComponent {
  public environment = environment;
  private NUM_OF_STATIC_COLS = 2;
  @Input() header: any;
  @Input()
  set columnConfig(columnConfig: Array<any>) {
    /* Various component setup */
    this._columnConfig = columnConfig;
    this.columnWidth = 100 / (columnConfig.length + this.NUM_OF_STATIC_COLS);
    // Sort items using defaultOrderedBy key on column config
    const defaultOrderedColumn = columnConfig.find(
      ({ defaultOrderedBy = false }) => defaultOrderedBy,
    );
    // tslint:disable-next-line: no-unused-expression
    defaultOrderedColumn && this.sortHeaderItems(defaultOrderedColumn.key);
  }
  @Input() withRowCheckBoxes: boolean = false;
  @Output() rowChecked = new EventEmitter<{ header: any; item: any; bulkMode: boolean }>();
  @Input() runsToUncheck = [];
  // tslint:disable: variable-name
  public _columnConfig: any;
  public columnWidth: number;
  public sort = '';
  public sortDir = 'DESC';

  ngOnChanges(changes) {
    if (changes.runsToUncheck && changes.runsToUncheck.previousValue !== undefined) {
      this.header.items.map((runItem) => {
        if (this.runsToUncheck.includes(runItem.runItemId)) {
          runItem.checked = false;
        }
        return runItem;
      });
    }
  }

  sortHeaderItems(column: string) {
    this.sort = column;
    this.sortDir = this.sortDir === 'ASC' ? 'DESC' : 'ASC';
    if (this.header) {
      this.header.items = this.header.items.slice().sort(desc(column));
    }

    if (this.sortDir === 'ASC') {
      this.header?.items.reverse();
    }
  }

  markSelected(header, item) {
    item.checked = !item.checked;
    this.rowChecked.emit({ header, item, bulkMode: false });
  }
}
